import { render, staticRenderFns } from "./UrunSabitKurToplam.vue?vue&type=template&id=2f052522&scoped=true"
import script from "./UrunSabitKurToplam.vue?vue&type=script&lang=js"
export * from "./UrunSabitKurToplam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f052522",
  null
  
)

export default component.exports